<template>
  <div class="project-box" :style="{ zoom: screenIndexWidth < 1600 ? 0.8 : 1 }">
    <div
      style="
        display: flex;
        width: 100%;
        border-bottom: 1px solid #acacac;
        padding-bottom: 10px;
        margin-bottom: 10px;
        align-items: center;
      "
    >
      <img
        class="titile-logo"
        src="../../../assets/images/titile-logo.png"
        alt=""
      />
      <div class="project-title">重点项目招商</div>
    </div>
    <div class="project-flex" v-show="projectlist.length">
      <div
        class="project-container"
        v-for="(item, index) in projectlist"
        :key="index"
        @click="handleDetails(item)"
      >
        <div
          style="
            display: flex;
            height: 40px;
            align-items: center;
            justify-content: space-between;
          "
        >
          <div style="display: flex">
            <div class="projectname">{{ item.projectName }}</div>
            <div class="tag1" v-if="item.industryChainCategory">
              {{ item.industryChainCategory }}
            </div>
          </div>
          <div class="address">
            {{ item.countyName }}
          </div>
        </div>
        <div class="project-main">
          <span> {{ item.industryChainCategory }}</span>
          <span>{{ item.investmentEstimate }}万（人民币）</span>
          <span>{{ item.area }}亩</span>
        </div>
      </div>
    </div>
    <div class="land-no" v-if="!projectlist.length">
      <div class="land-no-img">
        <img src="../../../assets/images/home/no-data1.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import { projectList, getProjectAll } from "@/api/setting/project";
export default {
  props: {
    county: {
      type: String,
      default: "53",
    },
  },
  data() {
    return {
      screenIndexWidth: null,
      projectlist: [],
      search: {
        projectLevel: 1,
        approvalStatus: 3,
        keyProjects: "1",
      },
    };
  },
  watch: {
    county(val) {
      this.search.county = val;
      this.getProjectList();
    },
  },
  created() {},
  mounted() {
    this.screenIndexWidth = window.screen.width; //初始化网页宽度
    this.getProjectList();
  },
  methods: {
    getProjectList() {
      // getProjectAll(this.search).then((res)=>{

      //   if(res.data.success){
      //     this.projectlist = res.data.data
      getProjectAll(this.search).then((res) => {
        if (res.data.success) {
          this.projectlist = res.data.data;
        }
      });
      // projectList(this.search).then((res) => {
      //   if (res.data.success) {
      //     this.projectlist = res.data.data.records;

      //   }
      // })
    },
    handleDetails(item) {
      this.$router.push({
        path: "/project/detail",
        query: { id: item.id },
      });
    },
  },
};
</script>

<style  scoped>
.project-box {
  width: calc(100% - 20px);
  height: 100%;
  /* box-shadow: 4px 0 10px #dddddd; */
  margin: 0 10px;
  padding: 0 10px;
}

.project-title {
  padding-left: 10px;
  /* width: 100%; */
  /* padding-bottom: 10px; */
  /* margin-bottom: 10px; */
  /* border-bottom: 1px solid #acacac; */
  font-size: 1.25rem;
  font-weight: 600;
}

.project-flex {
  display: flex;
  justify-content: space-between;
  /* align-items: center; */
  flex-wrap: wrap;
  height: 400px;
  /* background: red; */
  overflow-y: scroll;
  align-content: flex-start;
}
.project-flex::-webkit-scrollbar {
  width: 4px;
  background-color: #cfe0f5;
  border-radius: 4px;
}

.project-flex::-webkit-scrollbar-thumb {
  background-color: rgba(113, 155, 199, 0.7);
  border-radius: 4px;
}

.project-container {
  width: 48%;
  height: 80px;
  border-radius: 4px;
  border: 1px solid #d1d1d1;
  margin-bottom: 10px;
  padding: 5px 5px;
  cursor: pointer;
}

.tag1 {
  padding: 0 5px;
  height: 26px;
  background: #dbffff;
  color: #26c6b8;
  line-height: 26px;
  font-size: 0.85rem;
  max-width: 100px;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.project-main {
  display: flex;
  height: 40px;
  align-items: center;
}

.project-main span {
  padding-right: 20px;
  font-size: 0.85rem;
  color: #2d2d2d;
}

.projectname {
  font-size: 0.85rem;
  color: #000000;
  margin-right: 10px;
  max-width: 300px;
  height: 30px;
  line-height: 30px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 600;
}
.land-no {
  width: 100%;
  height: 80%;
  background: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
}
.land-no-img {
  width: 216px;
  height: 120px;
}
.land-no-img > img {
  width: 100%;
  height: 100%;
}
.address {
  max-width: 150px;
  /* background: red; */
  font-size: 0.85rem;
  height: 40px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 40px;
}
.titile-logo {
  width: 40px;
  height: 20px;
}
</style>